var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "title" }, [_vm._v("Соцсети")]),
    _c(
      "div",
      {
        staticClass: "socials",
        class: {
          disabled: _vm.preview,
        },
      },
      [
        _vm._l(_vm.socials, function (social) {
          return [
            !_vm.localValue[social.id].link && _vm.edited !== social.id
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.html",
                        value: {
                          container: "#app",
                          trigger: "hover blur",
                          content: social.tooltip,
                          placement: "top",
                        },
                        expression:
                          "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: social.tooltip,\n          placement: 'top',\n        }",
                        modifiers: { html: true },
                      },
                    ],
                    key: social.id,
                    class: `social social--${social.id}`,
                    on: {
                      click: function ($event) {
                        return _vm.add(social)
                      },
                    },
                  },
                  [_c("social-icon", { attrs: { social: social.id } })],
                  1
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.socials, function (social) {
          return [
            _vm.edited === social.id
              ? _c("div", { key: social.id, staticClass: "item" }, [
                  _c(
                    "div",
                    { class: `item-icon item-icon--${social.id}` },
                    [_c("social-icon", { attrs: { social: social.id } })],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "edit-form" },
                    [
                      _c("c-input", {
                        staticClass: "text",
                        attrs: {
                          required: _vm.isSubmitted && _vm.errorText,
                          "required-message": _vm.isSubmitted && _vm.errorText,
                        },
                        on: {
                          enter: function ($event) {
                            return _vm.change(social)
                          },
                        },
                        model: {
                          value: _vm.localValue[social.id].tmpLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.localValue[social.id], "tmpLink", $$v)
                          },
                          expression: "localValue[social.id].tmpLink",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Отменить",
                                  placement: "top",
                                },
                                expression:
                                  "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Отменить',\n                placement: 'top',\n              }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass: "reset",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "close", color: "secondary" },
                            },
                            on: {
                              click: function ($event) {
                                return _vm.reset(social)
                              },
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Применить",
                                  placement: "top",
                                },
                                expression:
                                  "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Применить',\n                placement: 'top',\n              }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass: "apply",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "check", color: "success" },
                            },
                            on: {
                              click: function ($event) {
                                return _vm.change(social)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm.localValue[social.id].link
              ? _c("div", { key: social.id, staticClass: "item" }, [
                  _c(
                    "div",
                    { class: `item-icon item-icon--${social.id}` },
                    [_c("social-icon", { attrs: { social: social.id } })],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "view" },
                    [
                      _c(
                        "a",
                        { attrs: { href: _vm.localValue[social.id].link } },
                        [_vm._v(_vm._s(_vm.localValue[social.id].link) + " ")]
                      ),
                      _c("c-button", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover blur",
                              content: "Редактировать",
                              placement: "top",
                            },
                            expression:
                              "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                            modifiers: { html: true },
                          },
                        ],
                        staticClass: "edit",
                        attrs: { size: "iconic", icon: { icon: "edit" } },
                        on: {
                          click: function ($event) {
                            return _vm.edit(social)
                          },
                        },
                      }),
                      _c("c-button", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover blur",
                              content: "Удалить",
                              placement: "top",
                            },
                            expression:
                              "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Удалить',\n              placement: 'top',\n            }",
                            modifiers: { html: true },
                          },
                        ],
                        staticClass: "remove",
                        attrs: {
                          size: "iconic",
                          icon: { icon: "trash", color: "secondary" },
                        },
                        on: {
                          click: function ($event) {
                            return _vm.remove(social)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }